/**
 * Calculate the surcharge amount based on the billed amount and basis points.
 * @param billedAmount The total amount billed ($100 = 10000).
 * @param basisPoints The basis points to calculate the surcharge (300 = 3%).
 * @returns The calculated surcharge amount.
 */
export const calculateSurchargeAmount = (billedAmount: number, basisPoints: number) => {
  const surchargeAmount = billedAmount * (basisPoints / 10000);
  return surchargeAmount;
};

export const calculateSurchargeTotal = (billedAmount: number, basisPoints: number) => {
  return billedAmount + calculateSurchargeAmount(billedAmount, basisPoints);
};

export const calculateAppliedOrEstimatedSurcharge = (
  appliedSurchargeAmount: number,
  billedAmount: number,
  basisPoints: number
) => {
  return !!appliedSurchargeAmount && appliedSurchargeAmount > 0
    ? appliedSurchargeAmount
    : calculateSurchargeAmount(billedAmount, basisPoints);
};
